<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>通讯录</li>
                <li><a href="#">短信3天前已发</a></li>
            </ul>
        </div>
        
        <div class="rightinfo">
            <ul class="seachform">
                <li><label>手机号</label><input name="" v-model="mobile" type="text" class="scinput" /></li>
                <li><label>内容</label><input name="" v-model="content" type="text" class="scinput" style="width:300px;"/></li>
            </ul>
            <ul class="seachform">
                <li>
                    <label>发送时间</label>
                    <el-date-picker v-model="startTime"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期" />
                    <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerBeginDateAfter" placeholder="结束日期" />
                </li>
                <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
                <!-- <li><input class="cancel" type="button" value="导出"></li> -->
            </ul>    
            <div class="tools lh33">
                <b> 短信提交需进入人工审核，工作日审核时间一般3-5分钟，节假日审核有延时</b>
            </div>        
        
            <table class="tablelist">
                <thead>
                    <tr>
                    <th>手机号</th>
                    <th>短信内容</th>
                    <th v-if="isShowStatus==1">状态</th>
                    <th>发送时间</th>
                    <th>计费条数</th>
                    </tr>
                </thead>
                <tbody>                
                    <tr v-for="(item,index) in smsMtLogList" :class="{odd:index%2!=0}">
                    <td style="width:10%">{{item.mobile}}</td>
                    <td style="width:55%">{{item.content}}</td>
                    <td style="width:10%" v-if="isShowStatus==1" >{{item.status}}</td>
                    <td style="width:15%">{{item.createtime}}</td>
                    <td style="width:10%">{{item.sendcount}}</td>
                    </tr>                 
                </tbody>
            </table>
        
    
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            
        
            <div class="jian">&nbsp;</div>
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>短信问题排查方法 </b>
            </div>
            
            <ul class="infolist">
                <li><span>1、接收号码正确否？是否忘记添加在发送任务中？</span></li> 
                <li><span>2、是否曾欠费停机，当时不在服务区，或基站信号屏蔽有问题，可试拨打</span></li>
                <li><span>3、安装过短信过滤软件否，如360 管家卫士之类</span></li>
            </ul>
            </div> 
            
            
            <div class="tip">
                <div class="tiptop"><span>提示信息</span><a></a></div>
                
            <div class="tipinfo">
            <span><img src="../../assets/images/ticon.png" /></span>
            <div class="tipright">
            <p>是否确认对信息的修改 ？</p>
            <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
            </div>
            </div>
            
            <div class="tipbtn">
            <input name="" type="button"  class="sure" value="确定" />&nbsp;
            <input name="" type="button"  class="cancel" value="取消" />
            </div>
        </div>

        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            content:'',
            pageIndex:0,
            totalCount:0,
            smsMtLogList:[],
            startTime:'',
            isShowStatus:0,
            endTime:'',
            pickerBeginDateAfter: {
                disabledDate: (time) => {
                    let beginDateVal = this.startTime;
                    var date = new Date(beginDateVal)
                    var lastDay = this.getLastDay(date.getFullYear(), date.getMonth()+1)
                    var lastDayTime = date.getFullYear() + "-" + (date.getMonth()+1)+"-" + lastDay + " 23:59:59";
                    if (beginDateVal) {
                        return time.getTime() > new Date(lastDayTime) || time.getTime() < beginDateVal;
                    }
                }
            },
            getLastDay(year,month)   
            {   
                var new_year = year;  //取当前的年份   
                var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）   
                if(month>12)      //如果当前大于12月，则年份转到下一年   
                {   
                    new_month -=12;    //月份减   
                    new_year++;      //年份增   
                }   
                var new_date = new Date(new_year,new_month,1);        //取当年当月中的第一天   
                return (new Date(new_date.getTime()-1000*60*60*24)).getDate();//获取当月最后一天日期   
            },
            loadingShow: false,
            // loading: -1,
        }
    },
    mounted(){
        
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            // if(this.loading > 0)
            // {
            //     this.loadingShow = true;
            // }
            this.loadingShow = true;
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50,'mobile':this.mobile,'content':this.content,'source':'submit','startTime':this.startTime,'endTime':this.endTime};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsmtlog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    // if(that.loading < 0)
                    // {
                    //     that.loading = 1;
                    // }
                    that.smsMtLogList = res.data.smsMtLogList;
                    that.pageIndex = parseInt(pageIndex);
                    // that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.isShowStatus = res.data.isShowStatus;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsmtlog.vue